import BadgeResySelect from './BadgeResySelect';

export default BadgeResySelect;
